<template>
  <div class="the-box">
    <div>
      <h4>{{title}}</h4>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped>
.the-box {
  background: #fff;
  padding: 16px;
  margin-bottom: 32px;
  margin-left: 8px;
  margin-right: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/MBox.vue